import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Capacitor } from '@capacitor/core';

// import { enableProdMode } from '@angular/core';
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';


if (Capacitor.isNativePlatform()) {
  //preventing a native app to request for the favicon on every url update
  const favIcon = document.getElementById('favIcon');
  if (favIcon) {
    //update favicon from url to local data, small pixel image
    favIcon.setAttribute('href', 'data:;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAkSURBVHgB7cwxAQAACAJBNAj9W2oIFoa/ADe2T4FViICAoCV4ujsBeUD8BqkAAAAASUVORK5CYII=');
  }
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));



// if (environment.production) {
//   enableProdMode();
// }
//pve
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


// platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
//   if ('serviceWorker' in navigator && environment.production) {
//     navigator.serviceWorker.register('ngsw-worker.js', { type: 'module' });
//   }
// }).catch(err => console.log(err));